import React from "react";
import {
  Card,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Pagination,
} from "ui-kit-ck-consultant";

import Folder from "../../components/home/Folder";
import ModalEditFolder from "../../components/home/ModalEditFolder";

const ITEMS_PER_PAGE = 20;

export default class Folders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalEditFolder: false,
      modalEditIdx: null,
      activePage: 1,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.folders !== this.props.folders) {
      const totalPages = Math.max(
        1,
        Math.ceil(this.props.folders.length / ITEMS_PER_PAGE)
      );
      if (this.state.activePage > totalPages) {
        this.setState({ activePage: 1 });
      }
    }
  }

  handlePageChange = (page) => {
    this.setState({ activePage: page });
  };

  render() {
    const { folders } = this.props;
    const { activePage } = this.state;
    const startIdx = (activePage - 1) * ITEMS_PER_PAGE;
    const pageFolders = folders.slice(startIdx, startIdx + ITEMS_PER_PAGE);

    return (
      <>
        <Card
          title="Liste des dossiers"
          className="mb-10 mb-20-xl"
          classNameChildren="overflow-x-auto"
        >
          <Table
            className="tableCustom"
            empty={!folders.length ? "Aucun dossier" : ""}
          >
            <Thead>
              <Tr>
                <Th>N° dossier</Th>
                <Th>Date</Th>
                <Th>Immat.</Th>
                <Th>RDV</Th>
                <Th>Client</Th>
                <Th>Téléphone</Th>
                <Th>E-mail</Th>
                <Th>Compagnie</Th>
                <Th>Expert</Th>
                <Th>Statut</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {pageFolders.map((element, idx) => {
                const realIdx = startIdx + idx;
                return (
                  <Folder
                    key={realIdx}
                    idx={realIdx}
                    history={this.props.history}
                    id={element.id}
                    reference={element.reference}
                    token={element.token}
                    status={element.status}
                    date={element.date}
                    licensePlate={element.licensePlate}
                    insuredName={element.insuredName}
                    insuredPhone={element.insuredPhone}
                    insuredEmail={element.insuredEmail}
                    company={element.company}
                    appointmentExpertName={element.appointmentExpertName}
                    dateAppointment={element.dateAppointment}
                    hourAppointment={element.hourAppointment}
                    appointmentCanceled={element.appointmentCanceled}
                    getFolders={this.getFolders}
                    openModalEdit={() =>
                      this.setState({
                        isModalEditFolder: true,
                        modalEditIdx: realIdx,
                      })
                    }
                    deleteFolder={this.deleteFolder}
                    closeFolder={this.closeFolder}
                  />
                );
              })}
            </Tbody>
          </Table>
          {folders.length > ITEMS_PER_PAGE && (
            <Pagination
              activePage={activePage}
              itemsCountPerPage={ITEMS_PER_PAGE}
              totalItemsCount={folders.length}
              pageRangeDisplayed={5}
              onChange={this.handlePageChange}
              firstPageText="«"
              lastPageText="»"
              prevPageText="‹"
              nextPageText="›"
            />
          )}
        </Card>
        <ModalEditFolder
          onClose={(isReload) => {
            if (isReload) {
              this.getFolders();
            }
            this.setState({ isModalEditFolder: false });
          }}
          show={this.state.isModalEditFolder}
          folder={this.props.folders[this.state.modalEditIdx]}
        />
      </>
    );
  }
}
